"use client";

import { stripStega } from "@datocms/content-link";
import { useState } from "react";
import { HxBoundary } from "uberschrift";
import { getAllBlogPosts } from "src/app/cms";
import BlogCategoriesSwitch from "src/components/BlogCategoriesSwitch/BlogCategoriesSwitch";
import BlogPostTile from "src/components/BlogPostTile/BlogPostTile";
import ContentContainer from "src/components/styled/ContentContainer";
import { BlogMasonry } from "src/components/styled/Masonry";
import { BlogPostCategoriesType } from "src/enums";

export type BlogpostsProps = {
	blogposts: Awaited<ReturnType<typeof getAllBlogPosts>>;
};

export const Blogposts: React.FC<BlogpostsProps> = ({ blogposts }) => {
	const [currentCategory, setCategory] = useState<BlogPostCategoriesType>();

	const presentCategories = Array.from(
		new Set(
			blogposts
				.map(
					(post) =>
						stripStega(post.category) as BlogPostCategoriesType,
				)
				.filter(Boolean),
		),
	);

	return (
		<ContentContainer>
			<HxBoundary>
				<BlogCategoriesSwitch
					setCategory={setCategory}
					currentCategory={currentCategory}
					presentCategories={presentCategories}
				/>
				<HxBoundary>
					<BlogMasonry>
						{blogposts
							.filter((post) => {
								if (currentCategory === undefined) {
									return post;
								}

								return (
									stripStega(post.category) ===
										currentCategory ||
									post.additionalCategories?.includes(
										currentCategory,
									) === true
								);
							})
							.map((post) => {
								return (
									<BlogPostTile key={post.slug} {...post} />
								);
							})}
					</BlogMasonry>
				</HxBoundary>
			</HxBoundary>
		</ContentContainer>
	);
};
